var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"industry_proposal_tab_selection"}},[(!_vm.isMobile)?_c('new-filters-menu',{staticClass:"mb-4",attrs:{"show-outdated-warning":"","filters":['industrias', 'industria-mecanica']}}):_vm._e(),_c('offer-schedule-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }